import { UserNotificationType } from './UserNotificationType';
import { commentingNotificationIcon } from './commenting/CommentingNotificationIcon';
import { INotificationIcon } from './INotificationIcon';

// this is used to register notification icon for different notification types
export const NotificationIcons: _.Dictionary<INotificationIcon> = {
    [UserNotificationType.Commenting]: commentingNotificationIcon
};